/**
 * @generated SignedSource<<458e0c391bbc8a519568892d68a71636>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SendNoteByEmailInput = {
  captchaToken: string;
  clientMutationId?: string | null;
  emails: ReadonlyArray<string | null>;
  includeAiSummary?: boolean | null;
  includeNotes?: boolean | null;
  message: string;
  noteId: string;
};
export type SendNotesRecordingModalSendEmailMutation$variables = {
  input: SendNoteByEmailInput;
};
export type SendNotesRecordingModalSendEmailMutation$data = {
  readonly sendNoteByEmail: {
    readonly ok: boolean;
  } | null;
};
export type SendNotesRecordingModalSendEmailMutation = {
  response: SendNotesRecordingModalSendEmailMutation$data;
  variables: SendNotesRecordingModalSendEmailMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SendNoteByEmailPayload",
    "kind": "LinkedField",
    "name": "sendNoteByEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SendNotesRecordingModalSendEmailMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SendNotesRecordingModalSendEmailMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cb5dd660d30444342d65870604bca93e",
    "id": null,
    "metadata": {},
    "name": "SendNotesRecordingModalSendEmailMutation",
    "operationKind": "mutation",
    "text": "mutation SendNotesRecordingModalSendEmailMutation(\n  $input: SendNoteByEmailInput!\n) {\n  sendNoteByEmail(input: $input) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "ee81f2cb10c644e56d653b49cb550d65";

export default node;
